<p-dialog
  [(visible)]="display"
  modal="modal"
  width="400"
  [responsive]="true"
  (onHide)="onCloseClick()"
>
  <div class="add-portfolio">
    <div>
      <div>{{ 'label.Name' | translate }}</div>
      <div>
        <input
          maxlength="50"
          type="text"
          [(ngModel)]="portfolioSubmitData.name"
        />
        <hr-field-state-marker [field]="field?.name"></hr-field-state-marker>
      </div>
    </div>
    <div>
      <div>{{ 'label.AccountManager' | translate }}</div>
      <div>
        <select
          name="accountManagers"
          [ngModel]="accountManagers && portfolioSubmitData.accountManagerId"
          (ngModelChange)="
            accountManagers && (portfolioSubmitData.accountManagerId = $event)
          "
        >
          <option
            *ngFor="let item of accountManagers"
            [ngValue]="item?.adminId"
          >
            {{ item?.fullName }}
          </option>
        </select>
        <hr-field-state-marker
          [field]="field?.accountManager"
        ></hr-field-state-marker>
      </div>
    </div>
    <div>
      <div>{{ 'label.Comment' | translate }}</div>
      <div>
        <input type="text" [(ngModel)]="portfolioSubmitData.comment" />
        <hr-field-state-marker [field]="field?.comment"></hr-field-state-marker>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      (click)="onCreatePortfolio()"
      label="{{ 'label.Add' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCloseClick()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
<p-button
  type="button"
  class="ui-button-secondary top-left"
  (click)="onAddPortfolioClick()"
  label="{{ 'label.AddNew' | translate }}"
></p-button>
